module.exports = __webpack_public_path__ + "media/img/posts/post-1-a17f96793af68c457bee35681101a257.jpg";